module.exports = __webpack_public_path__ + "media/bootstrap-icons/cart-c2c12d23.svg";